import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

const BulkDownload = (props) => {

    return (
        <Dialog
            open={props.show}
            onClose={props.onClose}
            fullWidth
            maxWidth="xs"
        >
            <DialogContent sx={{ py: 2 }}>
                <Typography>
                    Do you want to download all approved MTs for this month, or since the last bulk download?
                </Typography>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'space-around', pb: 2 }}>
                <Button
                    variant="contained"
                    onClick={() => { props.saveFiles(false); props.onClose(); }}
                    sx={{ width: 100 }}
                >
                    All
                </Button>
                <Button
                    variant="contained"
                    onClick={() => { props.saveFiles(true); props.onClose(); }}
                    sx={{ width: 120 }}
                >
                    Since Last
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default BulkDownload